import type { DynamicClient } from '@dynamic-labs-sdk/client';

import { getZerodevProviderFromSettings } from '../getZerodevProviderFromSettings';

type GetZerodevChainProviderForNetworkIdProps = {
  networkId: string;
};

export const getZerodevChainProviderForNetworkId = (
  { networkId }: GetZerodevChainProviderForNetworkIdProps,
  client: DynamicClient
) => {
  const zerodevProvider = getZerodevProviderFromSettings(client);

  return zerodevProvider.multichainAccountAbstractionProviders?.find(
    (provider) => provider.chain === networkId
  );
};
